module.exports = __webpack_public_path__ + "img/signup_title.fa741185.png";